<div *ngIf="modalTitle" class="modal-header">
  <h5 class="modal-title">{{modalTitle}}</h5>
</div>

<div class="modal-body text-center">
  <span
    class="svg-icon svg-icon-5x svg-icon-primary"
    [inlineSVG]="ICONS.ICON_QUESTION_MARK"
  ></span>
  <p class="mt-3 fw-bold fs-4">{{modalMessage}}</p>
</div>

<div class="modal-footer py-3 d-flex justify-content-center gap-3">
  <button
    class="btn btn-light-primary btn-sm"
    (click)="answer.emit(true)"
    tabindex="-1"
    test-id="confirmation-modal.ok-button"
  >
    {{modalOkButton || ('COMMON.YES' | translate)}}
  </button>
  <button
    class="btn btn-primary btn-sm"
    (click)="answer.emit(false)"
    tabindex="1"
    test-id="confirmation-modal.cancel-button"
  >
    {{modalCancelButton || ('COMMON.NO' | translate)}}
  </button>
</div>
